export function initMultistepFormFocus() {
  document.addEventListener("htmx:afterSettle", (event) => {
    const target = event.detail.target
    if (!target || !target.classList.contains("multistep-form-wrapper")) return
    if (event.detail.requestConfig.verb !== "post") return
    target.focus({ preventScroll: true })
    requestAnimationFrame(() => {
      if (target.getBoundingClientRect().top < 0) {
        target.scrollIntoView({ behavior: "smooth", block: "start" })
      }
    })
  })
}
